export const lazyExec = (fn, ...args) => () => fn(...args);

export const createTestId = (prefix: string) => (id: string) => `${prefix}-${id}`;
